import { render, staticRenderFns } from "./MemberSearchIframe.vue?vue&type=template&id=39ccd549&"
import script from "./MemberSearchIframe.vue?vue&type=script&lang=ts&"
export * from "./MemberSearchIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports